<h2 class="heading-1">{{ title }}</h2>

<div class="feedback-container">
  <p class="body intro-copy">
    We're always working to improve Smart-fix. So we'd appreciate you taking a
    minute to tell us how we did.
  </p>

  <div class="rating-form">
    <div class="rating-resolved">
      <p class="body bold mb-2">Did it fix your issue?</p>
      <div class="resolve-buttons">
        <ng-container *ngFor="let option of resolvedOptions">
          <section
            (click)="selectOption(option)"
            (keydown.enter)="selectOption(option)"
            class="option"
            [class.checked]="option === selectedOption"
            tabindex="0"
          >
            <input
              type="radio"
              [name]="option"
              [id]="option"
              [value]="option"
              (ngModelChange)="selectOption(option)"
            />
            <label [for]="option"> {{ option }} </label>
          </section>
        </ng-container>
      </div>
    </div>
    <div class="star-rating">
      <p class="body bold mb-2">How would you rate your experience?</p>
      <div class="star-container">
        <ng-container *ngFor="let star of ratingScale; trackBy: trackByStar">
          <div
            class="star"
            [innerHTML]="starSvg"
            (click)="setRating(star)"
            (keydown.enter)="setRating(star)"
            [class.star-selected]="rating >= star"
          ></div>
        </ng-container>
      </div>
    </div>

    <div *ngIf="showPositiveMessage" class="thank-you-message">
      🎉
      <p class="body bold">Excellent! Thank you.</p>
    </div>

    <div class="feedback-text">
      <p class="body bold">What did you like or dislike about Smart-fix?</p>
      <textarea
        placeHolder="Type answer..."
        (ngModelChange)="onFeedbackTextInput()"
        [(ngModel)]="feedbackText"
        maxlength="500"
        tabindex="0"
        dgxQmSanitise="encrypt"
      ></textarea>
      <span class="char-count"> {{ feedbackText.length }}/500 </span>
    </div>
  </div>

  <section class="action-buttons-container">
    <div *ngIf="showErrorMessage" class="error-message">
      <i class="fa-light fa-circle-exclamation fa-lg error-icon"></i>
      <p class="body">Please provide feedback before submitting</p>
    </div>

    <button
      class="min-w-160 btn btn-primary"
      (click)="submitFeedback(feedbackText)"
      data-testid="try-smart-fix-button"
    >
      {{ submitButtonLabel }}
    </button>
    <button
      class="min-w-160 btn btn-secondary"
      (click)="goToBookEngineer()"
      data-testid="book-engineer-button"
    >
      Skip, book an engineer
    </button>
  </section>
</div>
